import { fetchDataAndProceed } from '../../config/utils';
import { METHOD_TYPES } from '../../config/constants';

export const getUsersList = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/usermanagement/brandusers', METHOD_TYPES.GET, data, callback);
};

export const getUserBasicInfo = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/usermanagement/userinfo', METHOD_TYPES.GET, data, callback);
};

export const getUserStats = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/usermanagement/analyticscount', METHOD_TYPES.GET, data, callback);
};

export const getUserEventHistogram = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/usermanagement/usereventsgraph', METHOD_TYPES.GET, data, callback);
};

export const getChatlogListFilters = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/usermanagement/chatFilters', METHOD_TYPES.GET, data, callback);
};

export const getUserChatlogList = (data, callback) => {
    return fetchDataAndProceed('/admin/v1/usermanagement/userchatsessions', METHOD_TYPES.POST, data, callback);
};


// WEBPACK FOOTER //
// ./src/data/redux/users_details/api.js